import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "@/routes";
import { isMockEnabled } from "@/lib/mock";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Aggressively refresh on focus is annoying for a wizard; keep it off.
      refetchOnWindowFocus: false,
      // 30s stale window so step transitions don't refetch.
      staleTime: 30 * 1000,
      retry: (count, err) => {
        // Don't retry 4xx — they're not transient.
        const status = (err as { status?: number })?.status ?? 0;
        if (status >= 400 && status < 500) return false;
        return count < 2;
      },
    },
  },
});

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      {isMockEnabled && (
        <div
          className="fixed bottom-4 right-4 z-50 rounded-full border border-amber-300 bg-amber-50 px-3 py-1.5 text-xs font-medium text-amber-800 shadow-sm"
          title="VITE_USE_MOCK is on — all API calls are served by an in-memory mock"
        >
          MOCK
        </div>
      )}
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
